function hexToRgb(hex) {
  const normalized = hex.replace('#', '');
  if (![3, 6, 8].includes(normalized.length)) return null;
  const parts = normalized.length === 3
    ? normalized.split('').map((c) => c + c)
    : normalized.match(/.{1,2}/g);
  if (!parts || parts.length < 3) return null;
  const [r, g, b] = parts.map((p) => parseInt(p, 16));
  if ([r, g, b].some((v) => Number.isNaN(v))) return null;
  return { r, g, b };
}

function luminance({ r, g, b }) {
  const a = [r, g, b].map((v) => {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
  });
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}

export function contrastRatio(colorA, colorB) {
  const a = typeof colorA === 'string' ? hexToRgb(colorA) : colorA;
  const b = typeof colorB === 'string' ? hexToRgb(colorB) : colorB;
  if (!a || !b) return 0;
  const l1 = luminance(a) + 0.05;
  const l2 = luminance(b) + 0.05;
  return Math.max(l1, l2) / Math.min(l1, l2);
}

export function contrastTextColor(backgroundColor, light = '#FFFFFF', dark = '#17151F') {
  const rgb = typeof backgroundColor === 'string' ? hexToRgb(backgroundColor) : backgroundColor;
  if (!rgb) return dark;
  return luminance(rgb) > 0.5 ? dark : light;
}

export function isLightColor(color) {
  const rgb = typeof color === 'string' ? hexToRgb(color) : color;
  if (!rgb) return true;
  return luminance(rgb) > 0.5;
}
